
import React from 'react';

// Componente ProblemSection
interface ProblemCardProps {
  icon: string;
  title: string;
  items: string[];
  colorClass: string;
}

const ProblemCard: React.FC<ProblemCardProps> = ({ icon, title, items, colorClass }) => (
  <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow group">
    <div className={`w-14 h-14 rounded-2xl ${colorClass} flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform`}>
      <i className={icon}></i>
    </div>
    <h3 className="text-xl font-bold text-dark mb-4">{title}</h3>
    <ul className="space-y-3">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-2 text-gray-600 text-sm">
          <span className="text-red-500 font-bold mt-0.5">•</span>
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const ProblemSection: React.FC = () => {
  return (
    <section id="problema" className="py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-medical mb-6 leading-tight">
            ¿Aún prescribe terapias oncológicas en papel o sistemas aislados?
          </h2>
          <p className="text-lg text-gray-500 font-medium">
            La oncología moderna exige precisión. El uso de herramientas no estandarizadas genera silos de información y eleva el riesgo clínico.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <ProblemCard 
            icon="fas fa-exclamation-circle"
            title="Riesgo en Prescripción Manual"
            colorClass="bg-red-50 text-red-500"
            items={[
              "Errores de transcripción en cálculos de BSA o AUC",
              "Dosis fuera de rangos terapéuticos recomendados",
              "Dificultad para estandarizar ajustes por toxicidad",
              "Protocolos inconsistentes entre ciclos"
            ]}
          />
          <ProblemCard 
            icon="fas fa-clock"
            title="Falta de Trazabilidad"
            colorClass="bg-orange-50 text-fhir"
            items={[
              "Incertidumbre en tiempos de administración real",
              "Dificultad para auditar procesos de mezcla",
              "Registro digital fragmentado o inexistente",
              "Vulnerabilidad ante inspecciones y auditorías"
            ]}
          />
          <ProblemCard 
            icon="fas fa-lock"
            title="Sistemas Cerrados y Costosos"
            colorClass="bg-medical/5 text-medical"
            items={[
              "Costos elevados ligados a EMRs genéricos",
              "Esquemas propietarios que impiden interoperar",
              "Implementaciones lentas que frenan la clínica",
              "Dependencia tecnológica de un solo proveedor"
            ]}
          />
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
